<p-chart type="line" [data]="data" [options]="chartOptions" [height]="'350px'" />
